import React, { Component } from 'react';
import DatePicker from 'react-date-picker';
import { TimePicker } from 'antd';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Row,
    Col,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import {
    getVerticals,
    fetchUsersRelative,
} from '../../services/api/offline-consult';
import { fetchLanguages } from '../../services/api/doctor';
import { fetchAllSponsors } from '../../services/api/sponsors';
import {
    getOnlineConsultDoc,
    bookOnlineScheduleConsultation,
    getUserData,
    fetchDoctorScheduleConsultationSlots,
} from '../../services/api/online-consultation-booking';
import LoadingComponent from '../common/LoadingComponent';
import Select from 'react-select';
import { Async } from 'react-select';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';

export default class onlineScheduleConsultationBooking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            verticalsResult: [],
            languagesResult: [],
            sponsorsResult: [],
            relativeResult: [],
            doctorSlotsResult: [],
            doctorId: null,
            requestedCallType: 'audio',
            consultationPayType: 'wallet',
            userInfo: {
                userId: null,
                userName: null,
                phone: null,
                entityId: null
            },
            date: new Date(),
            doctorSlot: null,
            time: null
        };
        this.verticalSelectRef = React.createRef();
        this.languageSelectRef = React.createRef();
        this.sponsorSelectRef = React.createRef();
        this.relativeSelectRef = React.createRef();

        this.debouncedLoadOptions = debounce(this._searchDoctors, 500);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.modalIsOpen && this.props.modalIsOpen) {
            this.setState({ loading: true });
            this.fetchVerticals();
            this.getLanguages();
            this.getSponsors();
            this.setState({ loading: false });
        }
    }
    fetchVerticals = () => {
        getVerticals().then((response) => {
            const arr = [];
            response.data.forEach((element) => {
                arr.push({ value: element.verticalId, label: element.verticalName });
            });
            this.setState({ verticalsResult: arr });
        });
    };

    getLanguages = () => {
        const arr = [{ value: null, label: 'Any' }];
        fetchLanguages()
            .then((response) => {
                response.data.forEach((element) => {
                    arr.push({ value: element.value, label: element.label });
                });
            })
            .finally(() => {
                this.setState({ languagesResult: arr });
            });
    };

    getSponsors = () => {
        const arr = [{ value: null, label: 'None' }];
        fetchAllSponsors()
            .then((response) => {
                response.data.forEach((element) => {
                    arr.push({ value: element.sponsorId, label: element.sponsorName });
                });
            })
            .finally(() => {
                this.setState({ sponsorsResult: arr });
            });
    };

    _searchDoctors = (val) => {
        console.log(val, 'inside search doc function[val]');
        const verticalId = this.verticalSelectRef.current.state.value
            ? this.verticalSelectRef.current.state.value.value
            : null;
        const consultationLanguage = this.languageSelectRef.current.state.value
            ? this.languageSelectRef.current.state.value.value
            : null;
        if (!verticalId) {
            toast.error('Please select a vertical first');
            return [];
        }
        return getOnlineConsultDoc(
            val,
            verticalId,
            consultationLanguage,
            this.state.userInfo.userId
        )
            .then((response) => {
                return response.data || [];
            })
            .then((result) => {
                return result.map((ele) => {
                    return {
                        label: `${ele.docName} - ${ele.docId}`,
                        value: ele.visitDoctorId,
                    };
                });
            })
            .catch((err) => {
                return [];
            });
    };

    onSubmit = () => {
        const { userInfo, doctorId, date, time, consultationPayType } = this.state;

        if (doctorId && userInfo.userId && date && time && consultationPayType) {
            this.setState({ loading: true });
            bookOnlineScheduleConsultation({
                userId: userInfo.userId,
                doctorId,
                relativeId: this.relativeSelectRef.current.state.value.value || null,
                requestedCallType: this.state.requestedCallType,
                consultationLanguage:
                    this.languageSelectRef.current.state.value.value || null,
                payType: consultationPayType,
                sponsorId: this.sponsorSelectRef.current.state.value
                    ? this.sponsorSelectRef.current.state.value.value
                    : null,
                requestedDate: moment(date).format('YYYY-MM-DD'),
                requestedTime: time,
                entityId: userInfo.entityId
            })
                .then((response) => {
                    if (response.message === 'serverError') {
                        throw new Error(response.errorMessage);
                    }
                    toast.success(`Successfully Booked Consultation`);
                    this.props.closeModal();
                })
                .catch((err) => {
                    toast.error(err.errorMessage || err.message);
                })
                .finally(() => this.setState({ loading: false, date: new Date(), time: null, userInfo: { phone: null, userId: null, userName: null, entityId: null } }));
        } else {
            toast.error('Please enter all required details');
        }
    };

    handleRequestedCallType = (type) => {
        this.setState({
            requestedCallType: type,
        });
    };

    handleConsultationPayType = (type) => {
        this.setState({
            consultationPayType: type,
        });
    };

    getUserDetails = (value) => {
        this.setState({
            userInfo: {
                ...this.state.userInfo,
                phone: value,
            }
        });
        if (value.length === 10) {
            getUserData(value)
                .then((res) => {
                    if (res.message === 'success') {
                        this.setState({
                            userInfo: {
                                ...this.state.userInfo,
                                userId: res.data[0].userId,
                                userName: res.data[0].userName,
                                entityId: res.data[0].entityId,
                            }
                        });
                        this.getUserRelative(res.data[0].userId);
                    } else {
                        toast.error(res.errorMessage);
                    }
                })
                .catch((err) => {
                    toast.error(err.errorMessage || err.message);
                });
        }
    };

    getUserRelative = (val) => {
        this.setState({
            loading: true,
        });
        fetchUsersRelative(val)
            .then((response) => {
                const relatives = [
                    {
                        value: null,
                        label: 'Self',
                    },
                ].concat(
                    response.data.map((ele) => ({
                        label: `${ele.relativeName}(${ele.relationName})`,
                        value: ele.relativeId,
                    }))
                );
                this.setState({
                    relativeResult: relatives,
                });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    getDoctorSlots = (doctorId) => {
        this.setState({
            loading: true,
            doctorId,
        });
        fetchDoctorScheduleConsultationSlots(doctorId, { ops: 1, uid: this.state.userInfo.userId })
            .then((response) => {
                if (response && response.data && response.data.length > 0) {
                    this.setState({
                        doctorSlotsResult: response.data,
                    });
                } else {
                    toast.error('Doctor is not available');
                }
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    render() {
        return (
            <>
                <Modal
                    isOpen={this.props.modalIsOpen}
                    toggle={() => this.props.closeModal()}
                >
                    <ModalHeader
                        className="bg-primary"
                        toggle={() => this.props.closeModal()}
                    >
                        Book Online Consult
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label for="userPhoneNumber">Phone Number</Label>
                                    </Col>
                                    <Col>
                                        <Input
                                            name="userPhoneNumber"
                                            id="userPhoneNumber"
                                            type="number"
                                            value={this.state.userInfo.phone}
                                            onChange={(e) => this.getUserDetails(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label for="userName">User Name</Label>
                                    </Col>
                                    <Col>
                                        <Input
                                            name="userName"
                                            id="userName"
                                            type="text"
                                            value={
                                                this.state.userInfo.userId && this.state.userInfo.userName
                                                    ? `${this.state.userInfo.userId}-${this.state.userInfo.userName}`
                                                    : ''
                                            }
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label for="patientSelect">Relative</Label>
                                    </Col>
                                    <Col>
                                        <Row className="my-2">
                                            <Col>
                                                <Select
                                                    name="patientSelect"
                                                    id="patientSelect"
                                                    style={{ width: `100%` }}
                                                    isSearchable={false}
                                                    ref={this.relativeSelectRef}
                                                    placeholder="Select Relative"
                                                    options={this.state.relativeResult}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label for="sponsorSelect">Select Sponsor</Label>
                                    </Col>
                                    <Col>
                                        <Select
                                            name="sponsorSelect"
                                            id="sponsorSelect"
                                            isSearchable={true}
                                            ref={this.sponsorSelectRef}
                                            options={this.state.sponsorsResult}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label for="languageSelect">Select Language</Label>
                                    </Col>
                                    <Col>
                                        <Select
                                            name="languageSelect"
                                            id="languageSelect"
                                            isSearchable={true}
                                            ref={this.languageSelectRef}
                                            options={this.state.languagesResult}
                                            isLoading={this.state.languageLoading}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label for="verticalSelect">Select Vertical</Label>
                                    </Col>
                                    <Col>
                                        <Select
                                            name="verticalSelect"
                                            id="verticalSelect"
                                            isSearchable={true}
                                            ref={this.verticalSelectRef}
                                            options={this.state.verticalsResult}
                                            isLoading={this.state.verticalLoading}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label for="doctorSearch">Search Doctor:</Label>
                                    </Col>
                                    <Col>
                                        <Async
                                            name="doctorSearch"
                                            id="doctorSearch"
                                            loadOptions={this.debouncedLoadOptions}
                                            onChange={(e) => {
                                                this.getDoctorSlots(e.value);
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label
                                            style={{
                                                fontFamily: 'Inter, sans-serif',
                                            }}
                                        >
                                            Date:
                                        </Label>
                                    </Col>
                                    <Col>
                                        <DatePicker
                                            className="rounded-xl border-4 border-blue-500 bg-gray-50 shadow-md px-3 py-2 w-50"
                                            onChange={(date) => {
                                                const doctorSlot = this.state.doctorSlotsResult.filter(
                                                    (ele) =>
                                                        new Date(ele.date).toDateString() ===
                                                        date.toDateString()
                                                );

                                                this.setState({
                                                    date,
                                                    doctorSlot: doctorSlot[0] || null,
                                                });
                                            }}
                                            value={this.state.date}
                                            tileDisabled={({ date }) =>
                                                !this.state.doctorSlotsResult.some(
                                                    (d) =>
                                                        new Date(d.date).toDateString() ===
                                                        date.toDateString()
                                                )
                                            }
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col className="col-3">
                                        <Label
                                            style={{
                                                fontFamily: 'Inter, sans-serif',
                                            }}
                                        >
                                            Select Slot:
                                        </Label>
                                    </Col>
                                    <Col>
                                        <Select
                                            isSearchable={false}
                                            options={
                                                this.state.doctorSlot && this.state.doctorSlot.slots
                                                    ? this.state.doctorSlot.slots.map((slot) => ({
                                                        value: slot,
                                                        label: slot,
                                                    }))
                                                    : []
                                            }
                                            onChange={(ele) => {
                                                this.setState({
                                                    time: ele.value
                                                });
                                            }}
                                        />
                                        <Row className="my-2 mx-2">
                                            <div style={{ display: 'flex' }}>
                                                <Col>
                                                    <Input
                                                        name="consultationPayType"
                                                        id="consultationPayType"
                                                        type="checkbox"
                                                        value={this.state.consultationPayType}
                                                        checked={this.state.consultationPayType === 'wallet'}
                                                        onChange={() =>
                                                            this.handleConsultationPayType('wallet')
                                                        }
                                                    />
                                                    <Label>Wallet</Label>
                                                </Col>
                                                <Col>
                                                    <Input
                                                        name="consultationPayType"
                                                        id="consultationPayType"
                                                        type="checkbox"
                                                        value={this.state.consultationPayType}
                                                        checked={this.state.consultationPayType === 'free'}
                                                        onChange={() => this.handleConsultationPayType('free')}
                                                    />
                                                    <Label>Free</Label>
                                                </Col>
                                            </div>
                                        </Row>
                                        <Row className="my-2 mx-2">
                                            <div style={{ display: 'flex' }}>
                                                <Col>
                                                    <Input
                                                        name="callType"
                                                        id="callType"
                                                        type="checkbox"
                                                        value={this.state.sendSms}
                                                        checked={this.state.requestedCallType === 'audio'}
                                                        onChange={() => this.handleRequestedCallType('audio')}
                                                    />
                                                    <Label>Audio</Label>
                                                </Col>
                                                <Col>
                                                    <Input
                                                        name="callType"
                                                        id="callType"
                                                        type="checkbox"
                                                        value={this.state.sendSms}
                                                        checked={this.state.requestedCallType === 'video'}
                                                        onChange={() => this.handleRequestedCallType('video')}
                                                    />
                                                    <Label>Video</Label>
                                                </Col>
                                            </div>
                                        </Row>

                                    </Col>
                                </Row>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <div className="flex flex-row justify-end">
                            <div className="flex flex-col m-3">
                                {this.state.loading ? (
                                    <LoadingComponent />
                                ) : (
                                    <Button color="primary" onClick={this.onSubmit}>
                                        Book Consultation
                                    </Button>
                                )}
                            </div>
                            <div className="flex flex-col m-3">
                                <Button color="secondary" onClick={this.props.closeModal}>
                                    Close
                                </Button>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
